<form [formGroup]="groupForm">
  <div class="admin-input mb-2">
    <mat-form-field appearance="outline">
      <input #inputGooglePlacesRef matInput [formControl]="searchPlaces" [matAutocomplete]="autoPlaces" placeholder="Search by city or zip code" />

      <mat-autocomplete #autoPlaces="matAutocomplete" (optionSelected)="selectedPlace($event, inputGooglePlacesRef)">
        <mat-option *ngFor="let item of searchResultsPlaces | async" [value]="item">
          {{ item.placePrediction.text.text }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
  </div>
</form>
